import EmptyContentPlaceHolder from "components/Blocks/EmptyContentPlaceholder/EmptyContentPlaceholder";

export default EmptyContentPlaceHolder;
